<template>
    <vx-card id="loader">
        <h3 class="mb-4">Логи объявления {{ id }}</h3>

        <vs-table stripe :data="logs" max-items="23" class="mt-5">
            <template slot="header"></template>
            <template slot="thead">
                <vs-th>Время изменения</vs-th>
                <vs-th>Тип изменения</vs-th>
                <vs-th>Предыдущее значение</vs-th>
                <vs-th>Новое значение</vs-th>
                <vs-th>Пользователь</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td class="vs-lg-2">{{ tr.endDateTime | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.event }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.oldValue }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.newValue }}</vs-td>
                    <vs-td class="vs-lg-2">{{ tr.userId }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ad-logs',
    props: ['id'],
    data() {
        return {
            logs: [],
            initialized: false
        };
    },
    components: {},
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'logs/ad/' + this.id,
                method: 'GET',
                success: (data) => {
                    debugger
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.logs = data || [];
                    this.initialized = true;
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки логов топа.',
                        color: 'danger'
                    });
                }
            });
        },
        getStatusText(status) {
            return status == 1 ? 'Да' : 'Нет';
        },
        getResultText(result) {
            return result == null ? 'В обработке' : result == 1 ? 'Успешно' : 'Ошибка';
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
    tr > td.actions {
        white-space: nowrap;
    }
    tr > td {
        word-break: break-all;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
</style>
